import React from 'react'
import { Input, Select } from 'antd'

const SearchTagBrand = ({ handleChangeFieldSeach, hanldeChangeValueSearch, valueSearch, fieldSearch, placeholders }) => {

    const _handleChangeSelect = (field) => {
        handleChangeFieldSeach(field)
    }

    const _handleChangeSearch = (e) => {
        hanldeChangeValueSearch(e.target.value)
    }

    return (
        <div className='SearchTagBrand'>
            <Input.Group compact>
                <Select
                    value={fieldSearch}
                    style={{ width: '30%' }}
                    onChange={_handleChangeSelect}
                >
                    <Select.Option value="store">Store</Select.Option>
                    <Select.Option value="brand_name">Brand name</Select.Option>
                </Select>
                <Input
                    style={{ width: '70%' }}
                    value={valueSearch}
                    placeholder={`Search ${placeholders[fieldSearch]}`}
                    onChange={_handleChangeSearch}
                />
            </Input.Group>
        </div>
    )
}

export default SearchTagBrand
